import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/Memory/MemoryDiagnosticWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfflineDialog"] */ "/vercel/path0/components/common/offline-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpdateAvailableBanner"] */ "/vercel/path0/components/common/update-available-banner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/layout/breakpoint-display.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Figtree\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-figtree\"}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ForceLightMode"] */ "/vercel/path0/utils/helpers/forceLightMode.ts");
;
import(/* webpackMode: "eager", webpackExports: ["PreventZoom"] */ "/vercel/path0/utils/helpers/preventZoom.ts");
